// tienda/StatsStrip.jsx
// Compact event lifecycle showing how one order becomes operational truth.

import React from "react";
import { motion } from "framer-motion";
import { BadgeCheck, Box, MessageSquareText, Route, ScanLine } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const EVENTS = [
  { label: "Pedido registrado", icon: ScanLine },
  { label: "Recojo o fulfillment", icon: Box },
  { label: "Ruta orquestada", icon: Route },
  { label: "Cliente informado", icon: MessageSquareText },
  { label: "Entrega validada", icon: BadgeCheck },
];

export function StatsStrip() {
  return (
    <section className="border-b bg-white" style={{ borderColor: brand.line }} aria-label="Ciclo operativo de un pedido">
      <motion.div {...fadeUp} className="mx-auto max-w-7xl px-4 py-6">
        <p className="mb-4 text-center text-[10px] font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
          Cada acción genera visibilidad operativa
        </p>
        <div className="grid gap-2 sm:grid-cols-5">
          {EVENTS.map(({ label, icon: Icon }, index) => (
            <div key={label} className="relative flex items-center gap-3 rounded-xl px-3 py-2.5 sm:justify-center">
              <span
                className="grid size-9 shrink-0 place-items-center rounded-xl"
                style={{ background: `${brand.primary}10`, color: brand.primary }}
              >
                <Icon className="size-4" />
              </span>
              <span className="text-xs font-black" style={{ color: brand.ink }}>{label}</span>
              {index < EVENTS.length - 1 && (
                <span
                  className="absolute -right-2 top-1/2 hidden h-px w-4 sm:block"
                  style={{ background: brand.line }}
                  aria-hidden="true"
                />
              )}
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
